
import React,{ useState } from 'react';
import './App.css';
import Alert from './component/Alert';
// import About from './component/About';
import Navbar from "./component/Navbar";
import TextForm from "./component/TextForm";
// import { 
//   BrowserRouter as Router,
//    Routes,
//   // Switch,
//   Route,
// // Link
// } from "react-router-dom";


function App() {

  const[mode,setMode]=useState('light');
  const[alert,setAlert]=useState(null);

  function showAlert(message,type){
    setAlert({
      msg: message,
      type: type
    })
    setTimeout(() => {
      setAlert(null);
    }, 2000);
   
  }

  function toggleMode(){
    if(mode === 'light'){
      setMode('dark')
      document.body.style.backgroundColor='#0b2a28';
      showAlert("Dark mode Enable","success")
    }else{
      setMode('light')
      document.body.style.backgroundColor='white';
      showAlert("White mode Enable","success")
    }
  }
  

  

  return (
<>
{/* <Router> */}
<Navbar title="Play With Text" mode={mode} toggleMode={toggleMode}/>
     
      <Alert alert={alert}  />
  
    <div className="container my-3">

    <TextForm showAlert={showAlert} heading="Enter the text to analyze below " mode={mode}/>

    {/* <Routes>
        <Route path="/" element={ <TextForm showAlert={showAlert} heading="Enter the text to analyze below " mode={mode}/>} />
        <Route path="about/*" element={ <About mode={mode} />} />
      </Routes>  */}
       
       {/* Switch not use in present version */}
     {/*} <Switch>
          <Route exect path="/about">
            <About />
          </Route>
          <Route path="/">
          <TextForm showAlert={showAlert} heading="Enter the text to analyze below " mode={mode}/>
          </Route>
        </Switch> */}
    </div>  
    {/* </Router> */}
    </>
  );
}

export default App;
